<!-- @format -->

<!-- Desktop filter sidebar -->
<div class="plp-srlp-filters hmf-display-none hmf-display-lg-block">
	<div class="hmf-position-relative">
		<div class="skip-to-product-listing hmf-position-absolute"
			[class.skip-to-product-listing__visible]="skipLinkOpen()">
			<button hmf-button
				id="skip-to-products-btn"
				variant="secondary"
				size="large"
				(keydown.enter)="onSkipLinkEnter($event)"
				(blur)="skipLinkOpen.set(false)">
					Skip to Product Listing
			</button>
		</div>
	</div>
	<ng-content *ngTemplateOutlet="fulfillmentFilterTemplate"></ng-content>
	<!-- filter side bar for desktop -->
	<div class="background-base">
		@for (
			filter of productListFacetVOs();
			track filter.attrIdentifier;
			let filterIndex = $index
		) {
			<plp-components-filter
				[id]="
					filter.attrIdentifier
						? (filter.attrIdentifier | filterId:'desktop')
						: 'desktop-filter-index-' + filterIndex
				"
				[filter]="filter"
				[isMobile]="false"
				[disabled]="showSkeletonLoader()"
				[defaultOpen]="
					openFacets()?.[filter.attrName]?.open ?? false
				"
				[showMore]="
					openFacets()?.[filter.attrName]?.open
						? openFacets()?.[filter.attrName]?.showMore ?? false
						: false
				"
				[isPlp3Template]="isPlp3Template()"
				[refinementSource]="refinementSource()"
				(keydown.arrowup)="arrowUpKeyHandler($event)"
				(keydown.arrowdown)="arrowDownKeyHandler($event)"
				(facetToggled)="onFacetToggled($event)"
				(focusLostAfterReload)="
					focusFirstAccordion()
				">
			</plp-components-filter>
		}
	</div>
	<!--Embedded Filters Survey-->
	@if (
		deviceBreakPoint() > BreakPointSizeEnum.MEDIUM &&
		featureFlags().plpFilterResultSurveyEnabled
	) {
		<div
			id="filter_emb_form"
			class="hmf-mb-l hmf-mt-s hmf-mx-xxs hmf-mx-m-s">
		</div>
	}

</div>

<!-- Mobile filter drawer -->
<hmf-drawer #filterDrawer
	id="filterDrawer"
	tabindex="0"
	class="hmf-display-block hmf-display-lg-none"
	[className]="'filter-drawer'"
	[attr.aria-hidden]="!isFilterDrawerOpen()"
	[size]="'medium'"
	[noPadding]="true"
	[headerText]="'Filters'"
	[isCloseButtonSticky]="true"
	[focus]="true"
	[actions]="filterDrawerActions()"
	(closed)="onCloseFilterDrawer()">
	<div class="filter-panel-body">
		<div class="mobile-selected-filter"
			[class.hmf-display-none]="selectedFilterCount() === 0">
			<plp-components-filter-chips></plp-components-filter-chips>
		</div>
		<ng-content *ngTemplateOutlet="fulfillmentFilterTemplate"></ng-content>
		<div class="filters-container background-base">
			@for (
				filter of productListFacetVOs();
				track filter.attrIdentifier;
				let filterIndex = $index
			) {
				<div #filterContainer
					[class]="'filter-container-' + filter.attrIdentifier">
					<plp-components-filter
						[id]="
							filter.attrIdentifier
								? (filter.attrIdentifier | filterId:'mobile')
								: 'mobile-filter-index-' + filterIndex
						"
						[filter]="filter"
						[isMobile]="true"
						[disabled]="showSkeletonLoader()"
						[defaultOpen]="
							openFacets()?.[
								filter.attrName
							]?.open ?? false
						"
						[showMore]="
							openFacets()?.[
								filter.attrName
							]?.open
								? openFacets()?.[
										filter.attrName
									].showMore ?? false
								: false
						"
						[isPlp3Template]="isPlp3Template()"
						[refinementSource]="refinementSource()"
						(keydown.arrowup)="arrowUpKeyHandler($event)"
						(keydown.arrowdown)="arrowDownKeyHandler($event)"
						(facetToggled)="onFacetToggled($event)"
						(focusLostAfterReload)="focusFirstAccordion()">
					</plp-components-filter>
				</div>
			}

			<!--Embedded Filters Survey-->
			@if (
				deviceBreakPoint() <= BreakPointSizeEnum.MEDIUM &&
				featureFlags().plpFilterResultSurveyEnabled)
			{
				<div
					id="filter_emb_form"
					class="hmf-mt-s hmf-pb-s hmf-mx-s hmf-px-s">
				</div>
			}
		</div>
	</div>
</hmf-drawer>


<ng-template #fulfillmentFilterTemplate>
	@if (showShippingFilter()) {
		<hmf-accordion
			class="shipping-filter-accordion"
      		label="Shipping & Pickup"
			size="large"
      		[expandOverContent]="false"
      		[active]="true"
			(keydown.arrowup)="arrowUpKeyHandler($event)"
			(keydown.arrowdown)="arrowDownKeyHandler($event)"
			(focusLostAfterReload)="focusFirstAccordion()"
			>
			<div ngProjectAs="customAccordionContent">
				<plp-components-shipping-filter
					[optionVariant]="'selectable'"
					[disabled]="showSkeletonLoader()">
				</plp-components-shipping-filter>
			</div>
		</hmf-accordion>
	}
</ng-template>
